export default function PrerenderFallback() {
  const html = window.__PRERENDER_HTML;
  return html ? <div dangerouslySetInnerHTML={{ __html: html }} /> : null;
}
